import { Instagram } from "lucide-react";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.06-2.82h-3.2v12.9a2.6 2.6 0 1 1-2.6-2.6c.27 0 .53.04.78.11V7.13a5.86 5.86 0 0 0-.78-.05A5.8 5.8 0 1 0 15.34 13V8.53a7.5 7.5 0 0 0 4.35 1.39V6.72a4.28 4.28 0 0 1-3.09-.9z" />
  </svg>
);

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  return (
    <footer className="relative bg-[#141414] border-t border-[#262626] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <div className="font-display font-bold text-2xl tracking-tight text-white">HOWELL</div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#0055FF] font-bold">Transformations</div>
            <p className="mt-5 text-sm text-[#A3A3A3] leading-relaxed max-w-xs">
              Online transformation coaching with Ryan Howell. Fitness, nutrition,
              accountability, and discipline — for life.
            </p>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-white font-bold">Explore</h4>
            <div className="mt-5 flex flex-col gap-3 text-sm text-[#A3A3A3]">
              {[["About", "about"], ["Programs", "programs"], ["Results", "gallery"], ["FAQ", "faq"], ["Apply", "apply"]].map(([l, id]) => (
                <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollTo(id)} className="text-left hover:text-white transition-colors w-fit">
                  {l}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-white font-bold">Client & Legal</h4>
            <div className="mt-5 flex flex-col gap-3 text-sm text-[#A3A3A3]">
              <a data-testid="footer-checkin-link" href="/check-in" className="text-left hover:text-white transition-colors w-fit">Weekly Check-In</a>
              <a data-testid="footer-legal-waiver" href="/legal/waiver" className="text-left hover:text-white transition-colors w-fit">Coaching Waiver</a>
              <a data-testid="footer-legal-terms" href="/legal/terms" className="text-left hover:text-white transition-colors w-fit">Terms & Conditions</a>
              <a data-testid="footer-legal-privacy" href="/legal/privacy" className="text-left hover:text-white transition-colors w-fit">Privacy Policy</a>
              <a data-testid="footer-legal-cancellation" href="/legal/cancellation" className="text-left hover:text-white transition-colors w-fit">Cancellation Policy</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-white font-bold">Follow The Journey</h4>
            <div className="mt-5 flex gap-3">
              {[
                { icon: Instagram, label: "instagram", href: "https://instagram.com/fitbeast369" },
                { icon: TikTokIcon, label: "tiktok", href: "https://tiktok.com/@ryanhowell81" },
              ].map((s) => (
                <a
                  key={s.label}
                  data-testid={`footer-social-${s.label}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 flex items-center justify-center border border-[#262626] text-[#A3A3A3] hover:border-[#0055FF] hover:text-[#0055FF] transition-colors"
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
            <button
              data-testid="footer-apply-button"
              onClick={() => scrollTo("apply")}
              className="mt-6 bg-[#0055FF] text-white hover:bg-[#3377FF] transition-colors font-bold px-6 py-3 uppercase tracking-wide text-sm"
            >
              Apply For Coaching
            </button>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#262626] flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#5a5a5a]">
          <span>© {new Date().getFullYear()} Howell Transformations. Savannah, GA.</span>
          <a data-testid="footer-admin-link" href="/admin/login" className="hover:text-[#A3A3A3] transition-colors">
            Coach Login
          </a>
        </div>
      </div>
    </footer>
  );
};
